import { createSlice, PayloadAction } from '@reduxjs/toolkit';

import { ESliceNames } from '~/store/types';

import { NetworkFiltersState } from './types';

const initialState: NetworkFiltersState = {
  name: undefined,
  skills: undefined,
  position: undefined,
  sortBy: {
    label: 'Recently Joined',
    value: 'Recently Joined',
    payload: 'createdAt',
  },
};

export const networkFiltersSlice = createSlice({
  name: ESliceNames.NETWORK_FILTERS,
  initialState,
  reducers: {
    clear: () => initialState,
    update: (
      state,
      { payload }: PayloadAction<Partial<NetworkFiltersState>>,
    ) => {
      return { ...state, ...payload };
    },
  },
});

export const { actions: networkFiltersActions } = networkFiltersSlice;
export const networkFiltersReducer = networkFiltersSlice.reducer;
